<div class="maintenance flex column">
    <img src="../../assets/img/crewcus-logo" style="max-width: 250px;
    align-self: center;">

    <div><img src="../../../assets/img/404.svg" style="width: 25vw;"></div>

    <div>{{'Page not found' | translate}}</div>
    <div>{{'The link you clicked may be broken or the page may have been removed.' | translate}}</div>
    <div>{{'Take me back to' | translate}} <a href='{{homepage}}'>crewcus.com</a> </div>
</div>